import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { hasFinanceAccess } from "../../utils/roleAccess";

export default function FinanceProtectedRoute({ children }) {
  const { user, roleCapabilities } = useAuth();
  const userRoles = user?.claims_role || user?.roles || [];

  if (!hasFinanceAccess(userRoles, roleCapabilities)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
